import { environments } from 'environments/environment';
import { ajax } from '@setel/webcommon/exposes/ajax';
import { ITopupPaymentTransaction } from 'shared/interfaces/transaction.interface';
import { filterEmptyString, IPaginationParam } from 'lib/ajax-helper';
import {
  IndexPaymentsTransactionData,
  IndexPaymentsTransactionFilter,
  PaymentTransaction,
} from 'shared/interfaces/payments.interface';

const BASE_URL = `${environments.apiOpsBaseUrl}/api/payments`;

export const adminReadTransaction = (
  transactionId: string
): Promise<ITopupPaymentTransaction> =>
  ajax.get<ITopupPaymentTransaction>(
    `${BASE_URL}/admin/transactions/${transactionId}`
  );

export const indexTransactions = (
  params: Partial<IndexPaymentsTransactionFilter & IPaginationParam>
) => {
  const { dateRange, ...filter } = params;
  return ajax.get<IndexPaymentsTransactionData>(
    `${BASE_URL}/admin/transactions`,
    {
      params: filterEmptyString({
        ...filter,
        from: dateRange?.[0],
        to: dateRange?.[1],
      }),
      select: ({ data, headers }) => ({
        items: data,
        perPage: +headers['x-per-page'] || 0,
        nextPage: +headers['x-next-page'] || 0,
      }),
    }
  );
};

export const getTransaction = (id: string) =>
  ajax.get<PaymentTransaction>(`${BASE_URL}/admin/transactions/${id}`);
